<template>

    <v-card>

        <v-card-title>

            <v-icon class="mr-2">mdi-folder-multiple</v-icon>
            Documentos Técnicos

            <v-spacer></v-spacer>

            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" dense hide-details></v-text-field>

        </v-card-title>


        <!-- BREADCRUMB -->

        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="{ item }">

                <a @click="irRuta(item.path)">
                    {{ item.text }}
                </a>

            </template>
        </v-breadcrumbs>



        <!-- TABLA -->

        <v-data-table :headers="headers" :items="archivos" :search="search" dense class="elevation-1" item-key="path"
            :items-per-page="50">

            <template v-slot:item.nombre="{ item }">

                <v-icon class="mr-2" :color="iconColor(item)">
                    {{ iconoArchivo(item) }}
                </v-icon>


                <span v-if="item.tipo == 'carpeta'" class="blue--text text--darken-2" style="cursor:pointer"
                    @click="abrirCarpeta(item)">
                    {{ item.nombre }}
                </span>

                <a v-else :href="item.url" target="_blank">
                    {{ item.nombre }}
                </a>

            </template>



            <template v-slot:item.acciones="{ item }">

                <v-btn v-if="item.tipo == 'archivo'" icon small :href="item.url" target="_blank">
                    <v-icon>mdi-download</v-icon>
                </v-btn>

            </template>

        </v-data-table>

    </v-card>

</template>

<script>
import axios from "../../axios-auth.js";
export default {

    data() {
        return {

            search: "",

            rutaActual: "",

            archivos: [],

            headers: [
                { text: "Nombre", value: "nombre" },
                { text: "", value: "acciones", sortable: false, width: 80 }
            ]

        }
    },

    computed: {

        breadcrumbs() {

            let parts = this.rutaActual.split("/").filter(p => p)

            let items = [{ text: "Inicio", path: "" }]

            let acumulado = ""

            parts.forEach(p => {
                acumulado += (acumulado ? "/" : "") + p

                items.push({
                    text: p,
                    path: acumulado
                })
            })

            return items
        }

    },

    mounted() {
        this.cargarArchivos()
    },

    methods: {


        cargarArchivos(path = "") {

            this.rutaActual = path

            axios
                .get("/Ingenieria/GetDirectoriosArchivos", {
                    params: { path }
                })
                .then(res => {

                    this.archivos = res.data.sort((a, b) => {

                        if (a.tipo === "carpeta" && b.tipo !== "carpeta") return -1
                        if (a.tipo !== "carpeta" && b.tipo === "carpeta") return 1

                        return a.nombre.localeCompare(b.nombre)

                    })

                })

        },


        abrirCarpeta(item) {

            this.cargarArchivos(item.path)

        },


        irRuta(path) {

            this.cargarArchivos(path)

        },


        iconoArchivo(item) {

            if (item.tipo === "carpeta")
                return "mdi-folder"

            let ext = item.nombre.split(".").pop().toLowerCase()

            switch (ext) {

                case "pdf": return "mdi-file-pdf"
                case "xls":
                case "xlsx": return "mdi-file-excel"

                case "doc":
                case "docx": return "mdi-file-word"

                case "ppt":
                case "pptx": return "mdi-file-powerpoint"

                case "zip":
                case "rar": return "mdi-zip-box"

                case "jpg":
                case "png":
                case "jpeg": return "mdi-file-image"

                default: return "mdi-file"

            }

        },


        iconColor(item) {

            if (item.tipo === "carpeta") return "orange"

            let ext = item.nombre.split(".").pop().toLowerCase()

            switch (ext) {

                case "pdf": return "red"
                case "xls":
                case "xlsx": return "green"

                case "doc":
                case "docx": return "blue"

                case "ppt":
                case "pptx": return "deep-orange"

                default: return "grey"

            }

        }


    }

}

</script>